export default class Forms {
  static init() {
    Forms.initCustomFileInputs();
    $(document).on('gform_post_render', () => { Forms.onFormRender(); });
  }

  static initCustomFileInputs() {
    $('.custom-file-input').on('change', (e) => {
      Forms.handleFileUploadSelect(e);
    });
  }

  static onFormRender() {
    Forms.initCustomFileInputs();
  }

  static handleFileUploadSelect(e) {
    const input = $(e.currentTarget);
    const filename = Forms.removeFakePath(input.val());
    input.nextAll('.selected-file').html(filename);
  }

  static removeFakePath(filepath) {
    const sanitizedPath = filepath.replace('C:\\fakepath\\', '');
    return sanitizedPath;
  }
}
